module.exports = __webpack_public_path__ + "img/emotion_overview.5e4984a3.png";